const hackingExcellence = {
  name: 'Hacking Excellence',
  picture: 'https://i.imgur.com/N3ZSkC2.png',
  thumbnail: 'https://i.imgur.com/cZkbE6U.png',
  info:
    'I participated in the national hacking competition "Toaster Wars", in which I applied knowledge in penetration testing and hacking in general. I utilized techniques such MySQL, PHP, Pyton injection and stack overloading/overriding for vulnerable C programs. I also applied file forenciscs for recovery and decryption of files.',
  id: '5529feaa881faebd5b3f9966',
};

const arcoiris = {
  name: 'Arcoiris',
  picture: 'https://i.imgur.com/1f4SX1Y.gif',
  thumbnail: 'https://i.imgur.com/ifhcs50.png',
  info:
    'This is a very innovative e-commerce concept. It includes several pieces of a fully functional suite for the control and management of a web-commerce. These features include a web-based Point-Of-Sale system, an automated Low-Stocks alert system, an Overview system, and finally an order management system. There features are streamlined for efficiency and excellent situational awareness, such that the manager can allocate his energy towards decision making while the system takes care of the rest, dysplaying critical information where needed, what you need when you need it.',
  id: '5529feaa881faebd5b3f9968',
};

const cometa = {
  name: 'Cometa',
  picture: 'https://i.imgur.com/tY2GmN4.gif',
  thumbnail: 'https://i.imgur.com/yoipPTn.png',
  info:
    'This project is an innovative concept used as a part of a suite of web-based software for transaction management as well as large-scale in-out inventory management system. It incorporates a clean and intuitive design, and each table shows critical and practical information, thus allowing a manager to use less brain power trying to figure things out and focus on decision making.',
  id: '5529feaa881faebd5b3f9969',
};

const candyworld = {
  name: 'Candy World',
  picture: 'https://i.imgur.com/WDXFtTS.png',
  thumbnail: 'https://i.imgur.com/FyvnyM5.png',
  info:
    'I designed this as an e-commerce website for the Mexican wholesale candy business "Dulceria Arcoiris". It features elegant and simple front-end design, dynamically created from a MySQL database inventory system, and an admin panel for every inventory management task as well as for customer support and order management.',
  id: '5529feaa881faebd5b3f996d',
};

const hawxMe = {
  name: 'HaxW.me',
  picture: 'https://i.imgur.com/GTpe6Bv.png',
  thumbnail: 'https://i.imgur.com/tJoIGQz.png',
  info:
    "### The project\n\nHawx.me lets users sign up with their Github accounts, securely and seamlessly. Then you can browse through the available hackers, search by skill, see each other profiles and contact each other through our integration of Moxtra.\n\n### Why?\nWhen I arrived at LAHacks I didin't have a team, and the process of team forming was very annoying, inneficcient and disorganized. It pissed me off. So I decided to build something to try to fix the problem.\n\n### Technology\nI used the MEAN stack to build it. MongoDB for the database and Mongoose for object mapping, NodeJS as the server platform with ExpressJS, and AngularJS on the front-end MVC. I also integrated with Github to pull public information about the user and their  programming skills.",
  id: '5529feaa881faebd5b3f995e',
};

const wipi = {
  name: 'Wi-Pi',
  picture: 'https://i.imgur.com/2OvnrBH.png',
  thumbnail: 'https://i.imgur.com/G22U0hh.png',
  info:
    'My friends and I had been talking about this project for a couple weeks before hand, being SBCC students with complimentary majors, Computer Science and Computer Engineering. We decided to put our skills together and create a network of devices with sensors and actuators that could control any device, from home automation to monitoring patients in a field hospital. [Visit on Challengepost](http://challengepost.com/software/wipi).',
  id: '5529feaa881faebd5b3f995f',
};

const channels = {
  name: 'Channels',
  picture: 'https://i.imgur.com/MASBXgI.png',
  thumbnail: 'https://i.imgur.com/5vqfqiJ.png',
  info:
    'My team and I were featured on The Channels Newspaper.  [Visit Here](http://www.thechannels.org/features/2014/02/07/sbcc-computer-science-team-hacks-its-way-to-top-prizes/)',
  id: '5529feaa881faebd5b3f9960',
};

const cloudNes = {
  name: 'CloudNES',
  picture: 'https://i.imgur.com/9TZaVc9.jpg',
  thumbnail: 'https://i.imgur.com/hzNoIEa.png',
  info:
    'The Cloud NES was created in 36 hours at the LaHacks Hackathon. It constutites two apps, firstly there is the web app that at its frontend has an NES emulator and game cartridge selector, while on the backend we have a server that bridges this with the second app, an iOS app in the form of a digital NES controller. This way the user feels like playing an NES game completely digitally.\n\n ![webapp NES](https://i.imgur.com/0IlsxAZ.jpg)',
  id: '5529feaa881faebd5b3f9961',
};

const wannahang = {
  name: 'WannaHang',
  picture: 'https://i.imgur.com/HuXGljm.jpg',
  thumbnail: 'https://i.imgur.com/pwvTNYF.png',
  info:
    '## WannaHang\nWannahang was created in 36 hours at the Citrix Extended Google I/O Hackathon. It constitues a multiplatform web-app using a MEAN stack, architechturally divided into a MongoDB data access layer, a Node API, and an Angular powered front-end. The app allows users to easily and effortlessly scheduele times to meet, be it from an important business meeting, to hanging out with your friends.',
  id: '5529feaa881faebd5b3f9962',
};

const langSwitch = {
  name: 'LangSwitch',
  picture: 'https://i.imgur.com/Y7DFLGn.png',
  thumbnail: 'https://i.imgur.com/CMHXdY7.png',
  info:
    'A sleek, simple, lightweight language switching plugin. Using the power of jQuery and HTML5 to switch languages at the click of a button.',
  id: '5529feaa881faebd5b3f9965',
};

const jarvis = {
  name: 'Jarvis App',
  picture: 'https://i.imgur.com/ZRHe4N8.png',
  thumbnail: 'https://i.imgur.com/Yuxyahq.png',
  info:
    "## Jarvis Update\n\nJarvis App was created in 36 hours at the Hacktech Hackathon. Jarvis is an iOS app that gets all relevant information about the user. Jarvis collects information regarding your stocks, calendar events, RSS feeds, and even the weather. Jarvis then transforms all of this data into a human paragraph that is read aloud using a text-to-speech engine.\n\n### User Case\nAn user would set initially set stocks to follow, RSS feeds, email, etc. Only once. Afterwards simply set the alarm clock.\nIn the morning, when the alarm clock goes off the app gathers all the needed data. And when the user hits the snooze or dismiss button, the data (in readable format) is read by Siri's text-to-speech engine. Effectively letting the user go on with his tasks while Jarvis informs the user of all critical data, hands free and effortlessly.\n\n### Technology\nI took  care of the back-end in PHP to interact with several different APIs, gather the data and turned it into human readable format. In turn, a local API would return this human readable data to the iOS app.",
  id: '5529feaa881faebd5b3f9964',
};

const conexuns = {
  name: 'conexuns.com',
  picture: 'https://i.imgur.com/sx1kIT4.png',
  thumbnail: 'https://i.imgur.com/waF9GUN.png',
  info:
    "## Conexuns.com \nConexuns.com was created at Santa Barbara Startup Weekend 2014. The idea of the project is simple.\nAt startup weekend events it can be very complicated to either find a team, pitch an idea, find teammates and evaluate the skills of each individual. This usually happens face to face, person to person. But this becomes a huge issue with a big croud, and there isn't enough time to listen to all the pitches and the individuals' skills to form a team. Conexuns.com solves that problem.\n\n## Use case\nUsers can login to the website and create an account. In this particular case, the skills were divided into three categories Hackers (programmers), Hipsters (Designers), and Hustlers (Sales). As a result, while creating seamlessly an account, the user picks his skillset and edits his profile as pleased. Afterwards one can pitch an idea and/or browse through the categories to find teammates and learn more about them. This process is frictionless, faster, and efficient. One can then message/email the potential teammates and/or, talk directly to the person as most test users showed.\n\n## Technologies\nFor this project I used the MEAN stack. I used MongoDB on the database with Mongoose for Object Document Mapper. NodeJS and ExpressJS for the environment and web framework respectively. On the front-end I used AngularJS for MVC, and Bootstrap as a responsive CSS library. The project took around 8 hours to make. I did the whole MVP except for the logo, that was designed by a teammate.\n\n## Pictures:\n ![project] (https://i.imgur.com/JOioQXf.png)\n ![project] (https://i.imgur.com/WSKk224.png)\n ![project] (https://i.imgur.com/gbBH9my.png)\n ![project] (https://i.imgur.com/hfS1AME.png)\n ![project] (https://i.imgur.com/2L0MK5k.png)\n",
  id: '55c0149066b249291eb59f3b',
};

const vpass = {
  name: 'VPass',
  picture: 'https://i.imgur.com/rExeI9c.png',
  thumbnail: 'https://i.imgur.com/5W0vb1F.png',
  info:
    "##VPASS\nVPASS is a secure, low cost, campus management system that provides security and increases communication between the administration and staff. This VPASS software runs on Windows, OSX, Android, and iOS. School administrators can communicate to their campus through our web panel by recording a voice message and formatting a HTML rich message to send out to specific classrooms, teachers, students, or sections of the school. I developed the back-end functionality using PHP and MySQL, and made the user interface completely AJAX enabled. I also impletemented the voice messaging system using flash and javascript.\n\n## Technologies\nFor this project I took care of the the web-application. Since this was a single page application, it didn't really behave as a typical website. I used jQuery for DOM manipulation, a flash-based app for recoding voice messages and using PHP to save the audio file and dispatch information to the TCP server. I applied both input validation on the front-end and sanitation on the back-end, plus hot-loading content using AJAX with jQuery.",
  id: '5529feaa881faebd5b3f9963',
};

const cirqus = {
  name: 'Cirqus.xyz',
  picture: 'https://i.imgur.com/jDYo8Nk.png',
  thumbnail: 'https://i.imgur.com/EpU3PAq.png',
  info:
    '### The project\n\n[Cirqus.xyz](http://cirqus.xyz) Cirqus.xyz started as a "joke" project over a peculiarly funny weekend. The main idea is an anonymous community with real time chat on channels. Unlike typical Chatrooms, the functionality is sleeker, faster and modern.\n\n\n### Why?\nFor the lolz\n\n### Technology\nFor the front-end of the application I used ReactJS as the main framework, with libraries like react-router to handle client routing and Bootstrap as CSS. \nFor the development of it I switch to Gulp from Grunt.\n\nThe Back-End was fully done using Parse and Cloud-code.',
  id: '55c6846266b249291eb59f3c',
};

export const projects = [
  hackingExcellence,
  hawxMe,
  conexuns,
  cirqus,
  arcoiris,
  wannahang,
  cometa,
  candyworld,
  channels,
  wipi,
  cloudNes,
  jarvis,
  vpass,
  langSwitch,
];
